import { Injectable } from '@angular/core';
import { PreferenceValue } from '../../api/types/admin-user-preference';
import {
  capNotificationState,
  EMPTY_NOTIFICATION_STATE,
  isEmptyNotificationState,
  NotificationSeenState,
  parseNotificationState
} from '../../utils/notification-state-storage.util';
import { TenantPreference } from './tenant-preference';

/** NBO-2518: the bell's seen/read ticket ids, per user and tenant (tickets are tenant-scoped). */
export const NOTIFICATIONS_PREFERENCE = 'notifications';

/**
 * The notifications bell's seen/read state on the account (`notifications`, TENANT). Every change
 * adds ids to what is stored, so writes go through `update` and wait for the account's rows.
 */
@Injectable({ providedIn: 'root' })
export class NotificationStatePreference extends TenantPreference<NotificationSeenState> {
  constructor() {
    super({ type: NOTIFICATIONS_PREFERENCE });
  }

  protected empty(): NotificationSeenState {
    return EMPTY_NOTIFICATION_STATE;
  }

  protected parse(value: PreferenceValue): NotificationSeenState {
    return parseNotificationState(value);
  }

  protected serialize(state: NotificationSeenState): PreferenceValue | null {
    const capped = capNotificationState(state);
    return isEmptyNotificationState(capped) ? null : { seenIds: capped.seenIds, readIds: capped.readIds };
  }
}
